import { useTranslation } from "react-i18next";

/** Reserve the track even when idle so fetching never moves the content. */
export function LoadingBar({ active, label, value }: { active: boolean; label?: string; value?: number }) {
  const { t } = useTranslation();
  return (
    <div className="loading-track">
      {active && (
        <div
          role="progressbar"
          aria-label={label ?? t("async.loading")}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={value}
          className={`loading-bar${value == null ? " indeterminate" : ""}`}
          style={value == null ? undefined : { width: `${Math.max(0, Math.min(100, value))}%` }}
        />
      )}
    </div>
  );
}
